import { render, staticRenderFns } from "./releaseActivities.vue?vue&type=template&id=4c75a058&scoped=true&"
import script from "./releaseActivities.vue?vue&type=script&lang=js&"
export * from "./releaseActivities.vue?vue&type=script&lang=js&"
import style0 from "./releaseActivities.vue?vue&type=style&index=0&id=4c75a058&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c75a058",
  null
  
)

export default component.exports